export class PdfData {
    invoiceData: any;
    settings: any;
    pdfType: string;
}
